export default __webpack_public_path__ + "static/media/company_background_pic.bd80cbda.png";